export const ProcessStatuses = ['wait', 'process', 'finish', 'error', 'success'];
export const Directions = ['horizontal', 'vertical'];

export const Direction = {
    Horizontal: 'horizontal',
    Vertical: 'vertical'
}